import { TENANT } from '../../tenant'

export const TENANTS_WITH_MARKETPLACE_FUNCTIONALITY = new Set<TENANT>([
  TENANT.AT,
  TENANT.BE,
  TENANT.COM,
  TENANT.IT,
])
